import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Button, Col, Space, Breadcrumb, Form } from 'antd'
import {
  getHeaders,
  usersUrl,
  errorNotification,
  clientsUrl,
  projectsUrl,
  successNotification,
  statusUrl,
  projectTypesUrl,
  categoriesUrl
} from '../../../config'
// import { toast } from 'react-toastify'
import BasicInput from 'components/Forms/BasicInput'
// import DatePickerInput from 'components/Forms/DatePickerInput'
import SelectInput from 'components/Forms/SelectInput'
import DatePickerInput from 'components/Forms/DatePickerInput'
// import moment from 'moment'

const ClientForm = props => {
  const [department, setDepartment] = useState({
    name: '',
    description: '',
    deadline: new Date(),
    totalCost: 0,
    startAt: new Date(),
    status: '',
    owner: '',
    client: '',
    projectType: '',
    paymentDeadline: new Date(),
    serviceType: '',
    // certificatesProvided: '',
    recurringBill: false,
    retainerAccount: false
    // address: '',
    // dateOfBirth: '' || new Date(),
    // occupation: '',
    // passportNumber: '',
    // driversLicenseId: '',
    // confirmed: false
  })

  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [clients, setClients] = useState([])
  const [categories, setCategories] = useState([])
  const [users, setUsers] = useState([])
  const [status, setStatus] = useState([])
  const [types, setTypes] = useState([])
  const [showPaymentDeadline, setShowPaymentDeadline] = useState(false)

  const getUsers = () => {
    axios
      .get(usersUrl + '/all', {
        headers: getHeaders()
      })
      .then(res => {
        setUsers(res.data)
      })
      .catch(err => {
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error getting user, retry.')
      })
  }

  const getClients = () => {
    axios
      .get(clientsUrl, {
        headers: getHeaders()
      })
      .then(res => {
        setClients(res.data.data)
      })
      .catch(err => {
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error getting clients, retry.')
      })
  }

  const getCategories = () => {
    axios
      .get(categoriesUrl, {
        headers: getHeaders()
      })
      .then(res => {
        setCategories(res.data.data)
      })
      .catch(err => {
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error getting services, retry.')
      })
  }

  const getStatus = () => {
    axios
      .get(statusUrl, {
        headers: getHeaders()
      })
      .then(res => {
        setStatus(res.data.data)
      })
      .catch(err => {
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error getting user, retry.')
      })
  }

  const getTypes = () => {
    axios
      .get(projectTypesUrl, {
        headers: getHeaders()
      })
      .then(res => {
        let projTypes = res.data.data.sort((a, b) =>
          a.title.localeCompare(b.title)
        )
        setTypes(projTypes)
      })
      .catch(err => {
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error getting user, retry.')
      })
  }

  const handleInputChange = stateName => event => {
    setDepartment({ ...department, [stateName]: event.target.value })
  }

  const handleDateUpdate = stateName => date => {
    setDepartment({ ...department, [stateName]: date })
  }

  const handleSelect = stateName => value => {
    setDepartment({
      ...department,
      [stateName]: value
    })
  }

  const handleSubmit = event => {
    event.preventDefault()

    let data = {
      ...department,
      paymentDeadline: !showPaymentDeadline ? null : department.paymentDeadline
    }

    setLoading(true)
    axios
      .post(projectsUrl, data, {
        headers: getHeaders()
      })
      .then(res => {
        setLoading(false)
        props.history.push('/projects')
        successNotification('New Project Added')
      })
      .catch(err => {
        setLoading(false)
        if (err.response) {
          setServerErrors(err.response.data)
        }
        successNotification('Error adding project, retry.')
      })
  }

  useEffect(() => {
    getClients()
    getUsers()
    getStatus()
    getTypes()
    getCategories()
    // return () => {
    //   cleanup
    // }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              {/* <HomeOutlined /> */}
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/projects">Projects</Breadcrumb.Item>
            <Breadcrumb.Item>New Project</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="card mb-4rem">
            <div className="card-header">Add New Project</div>
            <div className="card-body">
              <Form className="p-2rem" layout="vertical">
                <div
                  className="row"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                  }}
                >
                  <div className="col-md-5">
                    <BasicInput
                      label="Project Name"
                      value={department.name}
                      name={'project name'}
                      placeholder="project name"
                      handleChange={handleInputChange('name')}
                      required={true}
                    />
                    {serverErrors.name &&
                      serverErrors.name.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Choose Project Category"
                      name="project category"
                      value={department.serviceType}
                      onChange={handleSelect('serviceType')}
                      optionList={categories.map(c => ({
                        label: c.title,
                        value: c.id
                      }))}
                      required={true}
                    />
                    {serverErrors.serviceType &&
                      serverErrors.serviceType.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Is this a retainer account"
                      name="retainer account"
                      value={department.retainerAccount}
                      onChange={handleSelect('retainerAccount')}
                      optionList={[
                        {
                          label: 'Yes',
                          value: true
                        },
                        {
                          label: 'No',
                          value: false
                        }
                      ]}
                      required={true}
                    />
                    {serverErrors.retainerAccount &&
                      serverErrors.retainerAccount.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  {!department.retainerAccount ? (
                    <div className="col-md-5">
                      <BasicInput
                        label="Project Budget"
                        value={department.totalCost}
                        name={'budget'}
                        placeholder="budget"
                        handleChange={handleInputChange('totalCost')}
                        required={true}
                      />

                      {serverErrors.totalCost &&
                        serverErrors.totalCost.map((err, i) => (
                          <div className="text-danger" key={i}>
                            {err}
                          </div>
                        ))}
                    </div>
                  ) : null}

                  <div className="col-md-5">
                    <DatePickerInput
                      label="Project Start Date"
                      value={department.startAt}
                      handleChange={handleDateUpdate('startAt')}
                      name="start date"
                      required={true}
                    />

                    {serverErrors.startAt &&
                      serverErrors.startAt.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <DatePickerInput
                      label="Project Deadline"
                      value={department.deadline}
                      handleChange={handleDateUpdate('deadline')}
                      name="deadline date"
                      required={false}
                    />
                    {serverErrors.deadline &&
                      serverErrors.deadline.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>
                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Choose Project Client"
                      name="client"
                      value={department.client}
                      onChange={handleSelect('client')}
                      optionList={clients.map(c => ({
                        label: c.name,
                        value: c.id
                      }))}
                      required={true}
                    />
                    {serverErrors.client &&
                      serverErrors.client.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5 ">
                    <SelectInput
                      placeholder="select"
                      label="Choose Project Owner"
                      name="project owner"
                      value={department.owner}
                      onChange={handleSelect('owner')}
                      optionList={users.map(c => ({
                        label: `${c.firstName} ${c.lastName}`,
                        value: c.id
                      }))}
                      required={true}
                    />
                    {serverErrors.owner &&
                      serverErrors.owner.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>
                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Choose Project Status"
                      name="status"
                      value={department.status}
                      onChange={handleSelect('status')}
                      optionList={status.map(c => ({
                        label: c.title,
                        value: c.id
                      }))}
                      required={true}
                    />
                    {serverErrors.status &&
                      serverErrors.status.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5 ">
                    <SelectInput
                      placeholder="select"
                      label="Choose Project Type"
                      name="project type"
                      value={department.projectType}
                      onChange={handleSelect('projectType')}
                      optionList={types.map(c => ({
                        label: c.title,
                        value: c.id
                      }))}
                      required={true}
                    />
                    {serverErrors.projectType &&
                      serverErrors.projectType.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  {!department.retainerAccount ? (
                    <div className="col-md-5 ">
                      <SelectInput
                        placeholder="select"
                        label="Is this a recurring bill?"
                        name="bill"
                        value={department.recurringBill}
                        onChange={handleSelect('recurringBill')}
                        optionList={[
                          {
                            label: 'Yes',
                            value: true
                          },
                          {
                            label: 'No',
                            value: false
                          }
                        ]}
                        required={true}
                      />
                      {serverErrors.recurringBill &&
                        serverErrors.recurringBill.map((err, i) => (
                          <div className="text-danger" key={i}>
                            {err}
                          </div>
                        ))}
                    </div>
                  ) : null}

                  {!department.retainerAccount ? (
                    <div className="col-md-5 ">
                      <SelectInput
                        placeholder="select"
                        label="Choose Custom Payment Deadline?"
                        name="show payment option"
                        value={showPaymentDeadline}
                        onChange={() => {
                          setShowPaymentDeadline(!showPaymentDeadline)
                        }}
                        optionList={[
                          {
                            label: 'Yes',
                            value: true
                          },
                          {
                            label: 'No',
                            value: false
                          }
                        ]}
                        required={true}
                      />
                    </div>
                  ) : null}

                  <div className="col-md-5 ">
                    {showPaymentDeadline ? (
                      <>
                        <DatePickerInput
                          label="Deadline for Payment"
                          value={department.paymentDeadline}
                          handleChange={handleDateUpdate('paymentDeadline')}
                          name="payment deadline"
                          required={false}
                        />

                        {serverErrors.paymentDeadline &&
                          serverErrors.paymentDeadline.map((err, i) => (
                            <div className="text-danger" key={i}>
                              {err}
                            </div>
                          ))}
                      </>
                    ) : null}
                  </div>

                  {serverErrors.nonFieldErrors &&
                    serverErrors.nonFieldErrors.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}

                  <Col md={24}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        marginBottom: '20px'
                      }}
                    >
                      <Space>
                        <Button onClick={() => props.history.push('/projects')}>
                          Go Back
                        </Button>
                        <Button
                          type="primary"
                          onClick={handleSubmit}
                          loading={loading}
                        >
                          Submit
                        </Button>
                      </Space>
                    </div>
                  </Col>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientForm
